@media (min-width: 1025px) {
  .wrapper :global([class*='footerSocialsAndDisclaimerContainer']) {
    height: 100px;
  }
}

.divider {
  height: 2px;
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 var(--cxy-spacing-4);

  & div {
    height: 100%;
    width: 100%;
    background-color: #77777751;
  }
}
